import { type CardLayout } from './AnalyticsCardGrid';

/**
 * Every arrangement of the analytics cards. The template is the whole decision:
 * naming an area places that card, and leaving it out drops the card entirely.
 */

const THREE_EVEN = 'repeat(3, minmax(0, 1fr))';
const NARROW_THEN_WIDE = 'minmax(0, 0.75fr) minmax(0, 1.25fr)';

/** The recency donut beside a wider activity chart. */
export const ENGAGEMENT_TOP: CardLayout = {
  columns: NARROW_THEN_WIDE,
  areas: `"recency activity"`,
};

export const OVERVIEW_WITH_COACHES: CardLayout = {
  columns: THREE_EVEN,
  areas: `
    "students engagement coaches"
    "students coverage   coverage"
  `,
};

/** No Coaches card, so Engagement takes the width it leaves. */
export const OVERVIEW_WITHOUT_COACHES: CardLayout = {
  columns: THREE_EVEN,
  areas: `
    "students engagement engagement"
    "students coverage   coverage"
  `,
};

/** A coach's own Coaching tab: My students full width, then Coverage beside My activity. */
export const COACHING_COACH: CardLayout = {
  columns: 'repeat(2, minmax(0, 1fr))',
  areas: `
    "students students"
    "coverage activity"
  `,
};

/** A coach's Coaching section on Overview: just My students, full width. */
export const MY_STUDENTS_ONLY: CardLayout = {
  columns: 'minmax(0, 1fr)',
  areas: `"students"`,
};

export const HOME_LAYOUT = {
  WITH_COACHES: {
    top: ENGAGEMENT_TOP,
    overview: OVERVIEW_WITH_COACHES,
  },
  WITHOUT_COACHES: {
    // Engagement comes up under the recency donut, which leaves the overview
    // grid with two cards and lets Coverage run the full height.
    top: {
      columns: NARROW_THEN_WIDE,
      areas: `
        "recency    activity"
        "engagement activity"
      `,
      // The derived order reads the template left to right, top to bottom, which
      // would put the activity chart between the donut and Engagement.
      stackedAreas: `"recency" "engagement" "activity"`,
    },
    overview: {
      columns: THREE_EVEN,
      areas: `
        "students coverage coverage"
        "students coverage coverage"
      `,
    },
  },
} as const satisfies Record<string, Readonly<{ top: CardLayout; overview: CardLayout }>>;
